import React from 'react';

export const Card = ({ children }) => (
    <div className="border rounded-xl shadow p-4 bg-white">{children}</div>
);

export const CardContent = ({ children, className }) => (
    <div className={className}>{children}</div>
);
